/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/AvataxTrustfileAccountCard.js
 */

import React from 'react';
import cupIcon from '../../assets/CUPIcon.png';
import AvataxTrustfileCard from '../deliveryObjects/AvataxTrustfileCard';

const CUPLink = 'https://admin.avalara.com/cup/a/';
const CARD_NAME = 'Avatax Trustfile Account';

const AvataxTrustfileAccountCard = ({ data, type }) => {
  return (
    <div className="Card">
      <div className="SectionTitle">
        <div>
          {CARD_NAME}
          <h1>{data.id}</h1>
        </div>
        <div className="logo-container">
          <a
            href={`${CUPLink}${data.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={cupIcon} alt="CUP Icon" className="CUPIcon" />
          </a>
        </div>
      </div>
      <div className="ResultsSection">
        <div className="DeliveryResultsSection">
          <AvataxTrustfileCard
            deliveryInfo={{
              ...data,
              displayName: data.deliverySystem,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AvataxTrustfileAccountCard;
